<!--<header>
  <img class="logo-img" src="{{logo}}" alt="" />
  <ul>
    <li><a class="hovername " routerLinkActive="is_active"  [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/']">Home</a></li>
    <li><a class="hovername" routerLinkActive="is_active"  [routerLink]="['/app-aboutus']">About</a></li>

    <li><a class="hovername"routerLinkActive="is_active" [routerLink]="['/app-contactus']">Contact</a></li>
  </ul>
</header>-->
<header style="box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px; ">
  <div class="container">
    <div class="at-logo">
      <img style="width: 177px; /* height: auto; */ margin-bottom: 5px; padding: 10px; }" src="{{logo}}" alt="Logo">

    </div>
   
    <div class="at-sign-in">
      <button class="button-79" [routerLink]="['/']">Login</button>
    </div>
  </div>
</header>

<!--<div class="header">-->
  <!-- Navigation -->
  <!--<nav class="navbar navbar-expand-lg navbar-light fixed-top" style="background-color:#fff !important">


    <div class="container d-flex justify-content-between" style="height:52px">
      <a class="navbar-brand" routerLink="">
        <img class="logo-img" src="{{logo}}" alt="" />
      </a>
      <span class="custom"></span>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse nav__links" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a class="hover_effect mx-3" routerLinkActive="is_active" aria-current="page" [routerLink]="['/home']">Home</a>
          </li>
          <li class="nav-item">
            <a class="hover_effect mx-3" routerLinkActive="is_active" aria-current="page" [routerLink]="['/app-contactus']">Contact Us</a>
          </li>
          <li class="nav-item">
            <a class="hover_effect mx-3" routerLinkActive="is_active" aria-current="page" [routerLink]="['/app-aboutus']">About Us</a>
          </li>
        </ul>
      </div>

    </div>

  </nav>


</div>-->
